/*
 * 部門選択コンポーネント
 */
<template>
	<div class="copy-search">
		<div class="copy-search-body">
			<!-- 呼出コード -->
			<c-searchcode
				v-show="is_disp_code"
				ref="refcode"
				:r_title="r_messages.text_code"
				:r_code_max="code_max"
				:r_code_min="code_min" ></c-searchcode>
			<!-- 名称 -->
			<c-searchname
				v-show="is_disp_name"
				ref="refname"
				:r_title="r_messages.free_word"
				:r_messages="r_messages"
				:r_max_length="r_default_name"
				:r_is_radio_hide="true"
			 ></c-searchname>
		</div>
		<div v-show="disp_btnSearch" class="conditions-list-btns">
			<!-- <button class="search-btn" v-on:click="onBtnSearch">{{r_messages.search_btn}}</button> -->
			<button class="search-btn" v-on:click="onBtnSearch"><i class="fa-solid fa-magnifying-glass"></i></button>
		</div>
	</div>
</template>
<script>
	 export default {
		mixins: [
			require('js/common/ifSearch.mixin.vue'),
		],
		props:{
			'r_disp':{},
		},
		data: function (){
			return{
			}
		},
		computed: {
			//! コード表示判定
			is_disp_code: function(){
				if(this.r_disp && this.r_disp.is_disp_code != undefined){
					return this.r_disp.is_disp_code;
				}
				return true;
			},
			//! 名称表示判定
			is_disp_name: function(){
				if(this.r_disp && this.r_disp.is_disp_name != undefined){
					return this.r_disp.is_disp_name;
				}
				return true;
			},
		},
		methods: {
			//! クリア
			clear:function(){
				this.$refs.refcode.setClear();
				this.$refs.refname.setClear();
			},
			//! 現在の検索パラメータを取得 ※ 上位から呼ぶので必須
			getSearchParam: function(){
				var param = {};

				var code = $.extend(true, {}, this.$refs.refcode.getParam());
				code = this.getConvertSearchValue('numeric_from_to', code);
				if(code.from.length>0){
					param["call_code_from"] = Number(code.from);
				}
				if(code.to.length>0){
					param["call_code_to"] = Number(code.to);
				}

				var name = this.$refs.refname.getParam();
				if( name.text.length>0){
					param["name"] = name.text;
					param["name_search_action"] = name.search_action;
				}

				return param;
			},
			validate: function(){
				var is = true;
				is = this.$refs.refcode.validate()?is:false;
				is = this.$refs.refname.validate()?is:false;
				return is;
			},
		},
	}
</script>



// WEBPACK FOOTER //
// resources/assets/js/parts_com/search/ifSearchSelection.vue